/* let jac_blog_swiper = null;
let jac_blog_breakpoint = 640;

let check_swiper = setInterval(() => {
    if(typeof window.Swiper != 'undefined' && document.querySelectorAll('.jac_blog_section .jac_blog_mob_slider').length > 0) {
        clearInterval(check_swiper);
        window.addEventListener('resize', jac_init_swiper);
        document.addEventListener('DOMContentLoaded', jac_init_swiper);
    }
});

function jac_init_swiper() {

    let screen_width = window.innerWidth;

    if(screen_width < jac_blog_breakpoint) {
        if(!jac_blog_swiper) {
            jac_blog_swiper = new Swiper('.jac_blog_section .jac_blog_mob_slider', {
                slidesPerView: 1.4,
                spaceBetween: 30,
                loop: false,
                centeredSlides: true,
                navigation: false,
                pagination: false,
                grabCursor: true
            });
        }
    } else {
        if(jac_blog_swiper) {
            jac_blog_swiper.destroy(true, true);
            jac_blog_swiper = null;
        }
    }
} */

let jac_blog_swipers = []; // Array to store multiple swipers
let jac_blog_breakpoint = 640;
let resizeTimer;

let check_swiper = setInterval(() => {
  if (typeof window.Swiper !== 'undefined' && document.querySelectorAll('.jac_blog_section .jac_blog_mob_slider').length > 0) {
    clearInterval(check_swiper);
    jac_init_swiper();
    window.addEventListener('resize', function() {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(jac_init_swiper, 150);
    });
  }
}, 100);

function jac_init_swiper() {
  let screen_width = window.innerWidth;
  let sliders = document.querySelectorAll('.jac_blog_section .jac_blog_mob_slider');

  if (screen_width < jac_blog_breakpoint) {
    // Create swipers for each slider
    sliders.forEach((slider, index) => {
      // Only create if not already initialized
      if (!slider.classList.contains('swiper-initialized')) {
        jac_blog_swipers[index] = new Swiper(slider, {
          slidesPerView: 1.4,
          spaceBetween: 30,
          loop: false,
          centeredSlides: true,
          navigation: false,
          pagination: false,
          grabCursor: true
        });
      }
    });
  } else {
    // Destroy all swipers on desktop
    jac_blog_swipers.forEach((swiper, index) => {
      if (swiper) {
        swiper.destroy(true, true);
        jac_blog_swipers[index] = null;
      }
    });
    jac_blog_swipers = [];
  }
}